import { css } from 'styled-components';
import { COLORS } from '../styles';

export const CommonInteractionStyling = css`
  &:focus {
    background-color: ${COLORS.white};
    box-shadow: 0px 4px 12px rgba(46, 127, 161, 0.25), 0px 0px 8px #2e7fa1;
    outline: none;

    &::after {
      background-color: ${COLORS.white};
    }
  }

  &:hover {
    background-color: ${COLORS.primary_20};
    color: ${COLORS.primary_600};
  }
  &:active {
    box-shadow: none;
    background-color: ${COLORS.primary_100};
    color: ${COLORS.primary_800};
  }
  &:disabled {
    box-shadow: none;
    background-color: ${COLORS.white};
    span {
      color: ${COLORS.neutral_300};
    }
    &::after {
      background-color: ${COLORS.white};
    }
  }
`;
